/**
 * @file baseFilters.enum.ts
 * @description
 * -----------------------------------------------------
 * Archivo que contiene los filtros base para todas las páginas
 * -----------------------------------------------------
 * @version 0.0.1a
 * @created 2025-05-27
 * @modified 2026-03-26
 * @author DLTCode
 * @author Daniel Sentamans
 * @modified Sergio Manjón
 * @copyright © DLTCode
 * @license Private
 * */

/* eslint-disable no-unused-vars */

export const enum BaseFilters {
  USERS = "users",
  USERS_ACTIVITY = "users-activity",
  USERS_VERIFICATION = "users-verification",
  COMPANIES = "companies",
  ONECOMPANY = "company",
  MAP = "map",
  ANOMALIES = "anomalies",
  DASHBOARD = "dashboard",
  SIGNAL_HISTORY = "signalHistory",
  REPORTS = "reports",
  SIGNAL_RECORDINGS = "signalRecordings",
  FINISH_REGISTRATION = "finish-registration",
}
